import $ from 'jquery';

class Beverage extends HTMLElement {
  constructor() {
    super();
    this.collections = collections;
    this.activeCollection = $('.collection-handle.active').data('handle');
  }
  connectedCallback() {
    this.changeCollection();
    this.renderProducts();
    this.mobileGridView();
  }

  changeCollection() {
    const self = this;

    $('.collection-handle').on('click', function () {
      $('.collection-handle').removeClass('active');
      $(this).addClass('active');
      $('.collection-title').text($(this).data('title'));
      self.activeCollection = $(this).data('handle');
      self.renderProducts();
    });
  }

  renderProducts() {
    const self = this;
    let products = self.collections.filter(
      (collection) => collection.handle == self.activeCollection
    )[0].products;
    let url = self.collections.filter(
      (collection) => collection.handle == self.activeCollection
    )[0].url;
    let html = '';
    if (!products.length) {
      return;
    }

    let height = products.length > 4 ? 800 : 400;
    $('.items-grid').css('min-height', height + 'px');
    $('.product-grid-item').removeClass('show');
    $('.collection-link').attr('href', url);

    //Skeleton SVG Loaded from the script initialized in the beverage-collections.liquid file

    setTimeout(() => {
      products.forEach((product, i) => {
        html += `
                    <div class="product-grid-item">
                        <a href="${product.url}" class="block">
                            <div class="relative aspect-1">
                            
                            ${skeletonSvg}
                            <img class="relative" src="${product.img}" alt="${product.title}" />`;

        if (product.announcement_tag != null) {
          html += `<span class="default-badge absolute"><span class='block relative -mb-[2px]'>${product.announcement_tag}</span></span>`;
        }
        html += `
                            </div>`;
        if (
          product.flavor_name &&
          product.category_can_size &&
          product.case_format
        ) {
          html += `
                   <p class="text-dark product-grid-item__split-title split-title-1">${product.flavor_name}</p>
                   <p class="text-dark product-grid-item__split-title split-title-2">${product.category_can_size}</p>
                   <p class="text-dark product-grid-item__split-title split-title-3">${product.case_format}</p>
                  `;
        } else {
          html += `<div class="text-dark product-grid-item__title">${product.title}</div>`;
        }

        html += `                </a>
                        
                        <p class="text-dark mt-3 mb-4 product-excerpt">${product.excerpt}</p>
                        <a class="product-cta text-dark uppercase cursor-pointer font-bold" href="${product.amazon_url}">${product.button_text}</a>
                    </div>
                `;
      });
      this.querySelector('.items-grid').innerHTML = html;
      setTimeout(() => {
        $('.product-grid-item').addClass('show');
      }, 100);
    }, 100);
  }

  mobileGridView() {
    $('.grid-view-1').on('click', function () {
      $(this).addClass('hidden');
      $('.grid-view-2').removeClass('hidden');
      $('#products-grid').addClass('grid-cols-1');
      $('#products-grid').removeClass('grid-cols-2');
    });
    $('.grid-view-2').on('click', function () {
      $(this).addClass('hidden');
      $('.grid-view-1').removeClass('hidden');
      $('#products-grid').addClass('grid-cols-2');
      $('#products-grid').removeClass('grid-cols-1');
    });
  }
}
customElements.define('beverage-homepage', Beverage);
